export default __webpack_public_path__ + "static/media/nssjc.a5520cfe.png";